import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import BannerWithCTA from '../../../components/BannerWithCta';
import MiniCardWithCta from '../../../components/CardWithCta';
import waChatbotIcon from '../../../assets/MiniCard/icon-wa-chatbot.svg';
import waIcon from '../../../assets/MiniCard/icon-wa.svg';
import businessIcon from '../../../assets/MiniCard/icon-business.svg';
import apiIcon from '../../../assets/MiniCard/icon-api.svg';
import reportIcon from '../../../assets/MiniCard/icon-report.svg';
import supportIcon from '../../../assets/MiniCard/icon-support.svg';

const WhatsApp = (props) => {
  const getGreetingTime = (momentDate) => {
    let greeting = null;

    if (!momentDate || !momentDate.isValid()) {
      return;
    }

    const split_afternoon = 12;
    const split_evening = 17;
    const currentHour = parseFloat(momentDate.format('HH'));

    if (currentHour >= split_afternoon && currentHour <= split_evening) {
      greeting = 'afternoon';
    } else if (currentHour >= split_evening) {
      greeting = 'evening';
    } else {
      greeting = 'morning';
    }

    return greeting;
  };

  return (
    <div className="WhatsAppPage">
      <BannerWithCTA
        title="Get started with WhatsApp Business API"
        description={
          <>
            Welcome to elfo Omnichannel Services! Connect with your customers on WhatsApp with our
            easy
            <br />
            and secure managed service.
          </>
        }
        // description="Welcome to elfo Omnichannel Services! Connect with your customers on WhatsApp with our easy and secure managed service."
        btnText="Request Access"
        btnUrl="/dashboard/contact-our-expert?product=whatsapp"
      />
      <div className="mini-card-wrapper">
        <MiniCardWithCta
          type={2}
          iconSrc={waChatbotIcon}
          title="WhatsApp Chatbot Automation"
          description="Supercharge sales and marketing with WhatsApp chatbot automation, personalized messaging, and efficient customer engagement."
        />
        <MiniCardWithCta
          type={2}
          iconSrc={waIcon}
          title="WhatsApp Broadcasting"
          description="Send transactional updates, OTPs, and WhatsApp marketing messages at scale."
        />
        <MiniCardWithCta
          type={2}
          iconSrc={businessIcon}
          title="Business Account Setup"
          description="Streamline WhatsApp Business account setup and management for efficient customer engagement and seamless communication."
        />
        <MiniCardWithCta
          type={2}
          iconSrc={apiIcon}
          title="API & Integration"
          description="Integrate your CRMs, E-commerce platforms, and more with your WhatsApp inbox via API for seamless connectivity."
        />
        <MiniCardWithCta
          type={2}
          iconSrc={reportIcon}
          title="Reporting & Analytics"
          description="Get actionable insights with detailed reports on customer support performance, including response times, busy hours, message sources, and more."
        />
        <MiniCardWithCta
          type={2}
          iconSrc={supportIcon}
          title="Dedicated Support"
          description="Expert business consultants and technical support teams ensure your digital customer experiences deliver ongoing value and success."
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { auth } = state;
  return {
    user: auth.user,
  };
};

export default connect(mapStateToProps, null)(WhatsApp);
